import Vue from 'vue'
const requireComponentMaterial = require.context(
    '@/components/material', true, /\.vue$/
)

requireComponentMaterial.keys().forEach(fileName => {
    const componentMaterialConfig = requireComponentMaterial(fileName);
    const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '');

    Vue.component(componentName, componentMaterialConfig.default || componentMaterialConfig)
})
